import { z } from 'zod';
import { CategoryKind } from './category.js';
import { MonthArray, MonthArrayNoNull } from './common.js';
export const ImportPayloadItem = z.object({
    name: z.string().min(1).max(160),
    budgets: MonthArrayNoNull,
    actuals: MonthArray,
});
export const ImportPayloadCategory = z.object({
    name: z.string().min(1).max(120),
    items: z.array(ImportPayloadItem).min(1),
});
export const ImportPayload = z.object({
    kind: CategoryKind,
    categories: z.array(ImportPayloadCategory).min(1),
});
export const ImportResponse = z.object({
    year: z.number().int(),
    category_count: z.number().int(),
    item_count: z.number().int(),
});
